import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import Loader from "react-loader-spinner"
import { createPlan } from "../../../../services/plans"
import configs from "../../../../configs"

import Card, { Title, Description } from "../../components/Card"
import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import Button from "../../../../components/Button"
import Notifications from "../../../../components/Notifications"

class Home extends React.Component {
  handleCreatePlan = next => {
    const { onCreatePlan, store, history } = this.props

    onCreatePlan(store.user.token).then(() => {
      history.push(next)
    })
  }

  render() {
    const {
      notifications,
      store: { plan, user }
    } = this.props

    const rePlanStatus = !!plan.id

    return (
      <div className="main-container main-container--light">
        <Header theme="dark" />

        <div className="content">
          <div
            className={`content_section_header ${!!notifications &&
              "content_section_header--dark"}`}
          >
            <div className="container">
              <div className="row">
                <div className="col-xl-10 offset-xl-1">
                  <h1 className="content_section_title">
                    Hello {user.name}, Welcome To Your Home Dashboard
                  </h1>
                </div>
              </div>
            </div>
            <Notifications />
          </div>

          {plan.loading ? (
            <Loader
              type="TailSpin"
              color="#0c4632"
              height={80}
              width={80}
              className="loader"
            />
          ) : (
            <div className="container">
              {user.list_role.includes(configs.roles.Participant) && (
                <>
                  <div className="row">
                    <div className="col-xl-8 offset-xl-2">
                      <Card className="card--yellow-light">
                        <Title>
                          {rePlanStatus
                            ? "Continue Building Your NDIS Pre Plan"
                            : "Create A New NDIS Support Pre-Plan"}
                        </Title>
                        <Description>
                          During this process you will provide information on
                          your current living situation and what services you
                          require to help you achieve your goals.
                        </Description>
                        {rePlanStatus ? (
                          <Button
                            routerLink={{ to: "/pre-plan/support-team" }}
                            className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                          >
                            Continue Building Plan
                          </Button>
                        ) : (
                          <Button
                            button={{ type: "button" }}
                            onClick={() => {
                              this.handleCreatePlan("/pre-plan")
                            }}
                            className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                          >
                            Create A New Pre-Plan
                          </Button>
                        )}
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-4 col-md-6 offset-xl-2">
                      <Card className="card--height-full card--green-light">
                        <Title>
                          Invite People To Be Part Of Your Support Team
                        </Title>
                        <Description>
                          Support Team members can review your plan and help you
                          by making recommendations about how to improve your
                          plan.
                        </Description>
                        {rePlanStatus ? (
                          <Button
                            routerLink={{ to: "/pre-plan/support-team" }}
                            className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                          >
                            Invite Support Team Members
                          </Button>
                        ) : (
                          <Button
                            button={{ type: "button" }}
                            onClick={() => {
                              this.handleCreatePlan("/pre-plan/support-team")
                            }}
                            className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                          >
                            Invite Support Team Members
                          </Button>
                        )}
                      </Card>
                    </div>
                    <div className="col-xl-4 col-md-6">
                      <Card className="card--height-full card--blue-light">
                        <Title>
                          Organise a video call with your Support Team
                        </Title>
                        <Description>
                          Teleconference with others to help develop your
                          pre-plan.
                        </Description>
                        <Button
                          routerLink={{ to: "/" }}
                          className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                        >
                          Coming Soon
                        </Button>
                      </Card>
                    </div>
                  </div>
                </>
              )}

              {user.list_role.includes(configs.roles.Guardian) && (
                <>
                  <div className="row">
                    <div className="col-xl-8 offset-xl-2">
                      <Card className="card--yellow-light">
                        <Title>See my participants</Title>
                        <Description>
                          See the participants who have added you to their
                          support team and review their plans.
                        </Description>
                        <Button
                          routerLink={{ to: "/my-participants" }}
                          className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                        >
                          See my participants
                        </Button>
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-4 col-md-6 offset-xl-2">
                      <Card className="card--height-full card--green-light">
                        <Title>Request access to edit a pre-plan.</Title>
                        <Description>
                          This will enable me to make changes which you can
                          review and accept or decline.
                        </Description>
                        <Button
                          routerLink={{ to: "/my-participants" }}
                          className="btn--secondary-light btn--width-lg btn--height-md btn--font-size-sm"
                        >
                          Request access
                        </Button>
                      </Card>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        <Footer />
      </div>
    )
  }
}

Home.propTypes = {
  notifications: propTypes.bool,
  onCreatePlan: propTypes.func.isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }).isRequired,
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number])
    })
  }).isRequired
}

Home.defaultProps = {
  notifications: false
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onCreatePlan: token => dispatch(createPlan(token))
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
